import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  diffWorkflowVersionsOptions,
  listWorkflowVersionsOptions,
  listWorkflowVersionsQueryKey,
  restoreWorkflowVersionMutation,
} from '../generated/api/@tanstack/react-query.gen.js';
import { adaptMutation } from './adapt-mutation.js';

const VERSION_PAGE_SIZE = 20;

export function useWorkflowVersions(workflowId: number | undefined) {
  const query = useQuery({
    ...listWorkflowVersionsOptions({ path: { id: String(workflowId) }, query: { limit: VERSION_PAGE_SIZE } }),
    enabled: !!workflowId,
  });
  if (query.isError) console.error('useWorkflowVersions: failed to load workflow versions', query.error);
  return query;
}

export function useWorkflowVersionDiff(
  workflowId: number | undefined,
  versionA: number | undefined,
  versionB: number | undefined,
) {
  return useQuery({
    ...diffWorkflowVersionsOptions({
      path: { id: String(workflowId), versionA: versionA ?? 0, versionB: versionB ?? 0 },
    }),
    enabled: !!workflowId && versionA !== undefined && versionB !== undefined,
  });
}

export function useRestoreWorkflowVersion() {
  const qc = useQueryClient();
  return useMutation({
    ...adaptMutation(
      restoreWorkflowVersionMutation(),
      ({ workflowId, version }: { workflowId: number; version: number }) => ({
        path: { id: String(workflowId), version },
      }),
    ),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: listWorkflowVersionsQueryKey({ path: { id: String(vars.workflowId) } }) });
    },
  });
}
